import { render, staticRenderFns } from "./graduationProve.vue?vue&type=template&id=0206c63a&scoped=true"
import script from "./graduationProve.vue?vue&type=script&lang=js"
export * from "./graduationProve.vue?vue&type=script&lang=js"
import style0 from "./graduationProve.vue?vue&type=style&index=0&id=0206c63a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0206c63a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0206c63a')) {
      api.createRecord('0206c63a', component.options)
    } else {
      api.reload('0206c63a', component.options)
    }
    module.hot.accept("./graduationProve.vue?vue&type=template&id=0206c63a&scoped=true", function () {
      api.rerender('0206c63a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/graduationProve/graduationProve.vue"
export default component.exports